import React, { useState, useEffect } from 'react'
import './TabCdiForms.scss'
import {Row, Col, Icon, Table, Modal, message, Spin, Select, Button} from 'antd'
import { getFormsPromise } from '../TabDeclarations/promises'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import {ModalPdfViewer} from '../../../InterestConflicts/components'
import { FormModal } from '../../../../layouts/Private/components'
import { deleteDeclarationsPromise } from '../../promises'
import { ReportService } from '../../../../services/'

const TabCdiForms = ({currentUser, client}) => {
    const { t } = useTranslation(["translations", "forms"])

    const clientName = (client.outsourcer && currentUser.subcliente) ? currentUser.subcliente.name : client.name
    const isInactiveUser = currentUser?.status === 'INACTIVE'
    const [isLoading, setIsLoading] = useState(false)
	const [items, setItems] = useState([])
	const [selectedForm, setSelectedForm] = useState({})
	const [formId, setFormId] = useState (null)
	const [showForm, setShowForm] = useState(false)
    const { confirm } = Modal;
    const [lastDoneDate, setLastDoneDate] = useState(null)
    const [pendientes, setPendientes] = useState([])
    const [enviados, setEnviados] = useState([])
    const [lastPendingDate, setLastPendingDate] = useState(null)
    const [lastEnviadoDate, setLastEnviadoDate] = useState(null)
    const Option = Select
    const [selectedTypeForm, setSelectedTypeForm] = useState(null)

    useEffect(() => {
		handleRefresh();
    }, []);

    const getDeclOptions = () => {
        var declOptions = []
        if (currentUser.category === 'COLABORADOR' || currentUser.category === 'PROVEEDOR') {
            if(client?.modules.includes('CDI-FORM-CDI')){
                declOptions.push(
                    {
                        id: 'CDI',
                        name: t('portal.cdi.option.CDI', {ns: 'forms'})
                    },
                )
            }
            if(currentUser.category === 'COLABORADOR' && client.modules.includes('CDI-FORM-REL')){
                declOptions.push(
                {
                    id: 'REL',
                    name: t('portal.cdi.option.REL', {ns: 'forms'})
                }
            )}
        } 
        if (currentUser.category === 'CLIENTE'){
            if(client.modules.includes('CDI-FORM-PATR')){
                declOptions.push(
                    {
                        id: 'PATR',
                        name: t('portal.cdi.option.PATR', {ns: 'forms'})
                    }
                )
            }
        } 
        if (currentUser.category === 'DIRECTOR'){
            if(client.modules.includes('CDI-FORM-DIR')){
                declOptions.push(
                    {
                        id: 'DIR',
                        name: t('portal.cdi.option.DIR', {ns: 'forms'})
                    }
                )
            }
        } 
        if (currentUser.category === 'COLABORADOR'){
            if(client.modules.includes('CDI-FORM-T')){
                declOptions.push(
                    {
                        id: 'TRAVEL',
                        name: t('portal.cdi.option.TRAVEL', {ns: 'forms'})
                    }
                )
            }
            if(client.modules.includes('CDI-FORM-G')){
                declOptions.push(
                    {
                        id: 'GIFT',
                        name: t('portal.cdi.option.GIFT', {ns: 'forms'})
                    }
                )
            }
            if(client.modules.includes('CDI-FORM-F')){
                declOptions.push(
                    {
                        id: 'FP',
                        name: t('portal.cdi.option.FP', {ns: 'forms'})
                    }
                )
            }
            if(client.modules.includes('CDI-FORM-S')){
                declOptions.push(
                    {
                        id: 'SOC',
                        name: t('portal.cdi.option.SOC', {ns: 'forms'})
                    }
                )
            }
        }
        if(client.modules.includes('FORM-PEP')){
            declOptions.push(
                {
                    id: 'PEP',
                    name: t('portal.cdi.option.PEP', {ns: 'forms'})
                }
            )
        }
        if(client.modules.includes('FORM-ODF')){
            declOptions.push(
                {
                    id: 'ODF',
                    name: t('portal.cdi.option.ODF', {ns: 'forms'})
                }
            )
        }
        return declOptions
    }

    const handleRefresh = () => {
        setIsLoading(true)
        getFormsPromise(currentUser.id).then((data) => {
            const itemCompletados = data.data.filter((item) => item.status === 'SENT')
            const itemEnviados = data.data.filter((item) => item.status !== 'SENT' && item.clasif === 'S')
            const itemPendientes = data.data.filter((item) => item.status !== 'SENT' && item.clasif !== 'S')
            const lastDone = itemCompletados.length > 0 ? moment(itemCompletados[0].recievedDate).format('DD/MM/YYYY') : null
            const lastFecPendiente = itemPendientes.length > 0 ? moment(itemPendientes[0].sendDate).format('DD/MM/YYYY') : null
            const lastFecEnviado = itemEnviados.length > 0 ? moment(itemEnviados[0].sendDate).format('DD/MM/YYYY') : null
            setLastDoneDate(lastDone)
            setEnviados(itemEnviados)
            setPendientes(itemPendientes)
            setLastPendingDate(lastFecPendiente)
            setLastEnviadoDate(lastFecEnviado)
			setItems(data.data)
			setIsLoading(false)
		})
    }

    const handlePdfViewer = (record) => {
		setFormId(record.id);
	}

    const onCancelPdfViewer = () => {
        setFormId(null);
    }

    const modalReady = () => {
		setIsLoading(false)
		setShowForm(false)
        handleRefresh();
        setSelectedForm({});
	}

    const showConfirm = (record) => {
        confirm({
            title: t('portal.cdi.msg.delete', { ns: 'forms'}),
            content: t('portal.cdi.msg.deleteMsg', { ns: 'forms'}),
            okType: 'danger',
            cancelText: t('messages.aml.cancel'),
            onOk() {
                setIsLoading(true)
                deleteDeclarationsPromise(currentUser.id,[record.id]).then((data) => {
                    if(data.success) {
                        message.success(t('messages.aml.declarations.delete.success'))
                        handleRefresh()
                    }else message.error(t('messages.aml.declarations.delete.error'))
                })
            },
            onCancel() {
            },
        });
    }
      const tableColumns = [
        {
            title: t('messages.aml.type'),
            dataIndex: 'type',
            width: '21%',
            sorter: (a, b) => { return a.type < b.type },
            render: (tipo) => {
                return t('messages.aml.type.' + tipo)
            }
        },
        {
            title: t('forms.label.folio', {ns: "forms"}),
            dataIndex: 'folio',
            width: '16%',
            sorter: (a, b) => { return a.folio < b.folio }
        },
        {
            title: t('messages.aml.request'),
            width: '13%',
            dataIndex: 'sendDate',
            render: (text) => {
                return moment(text).format('DD/MM/YYYY')
            },
            sorter: (a, b) => a.sendDate - b.sendDate,
        },
        {
            title: t('messages.aml.status'),
			dataIndex: 'statusDecl',
            render: (text, record) => {
                let status
                let date
                switch (text) {
                    case 'EVALUACION':
                        status = t('messages.aml.formKycStatus.' + text)
                        date = record.sendDate
                        break;
                    case 'AUTORIZADA':
                        status = t('messages.aml.formKycStatus.' + text)
                        date = record.sendDate
                        break;
                    case 'RECHAZADA':
                        status = t('messages.aml.formKycStatus.' + text)
                        date = record.sendDate
                        break;
                    case 'OBSERVADA':
                        status = t('messages.aml.formKycStatus.' + text)
                        date = record.sendDate
                        break;
                    default:
                        status = t('messages.aml.formKycStatus.PENDIENTE')
                        break;
                }

                return (
                    <>
                        <div>{ status }</div>
                    </>
                )
            },
		},
        {
            title: t('messages.aml.statusDate'),
            width: '13%',
            dataIndex: 'statusDate',
            render: (statusDate, record) => {
                return moment(statusDate).format('DD/MM/YYYY')
            },
            sorter: (a, b) => { return a.statusDate - b.statusDate },
        },
        {
            title: t('portal.cdi.msg.message2', {ns: 'forms'}),
            width: '15%',
            dataIndex: 'lastReminder',
            render: (lastReminder) => lastReminder ? moment(lastReminder).format('DD/MM/YYYY'): t('portal.cdi.msg.message3', {ns: 'forms'})
        },
        {
            width: '8%',
            render: ((record) => {
                return(
                    <Row>
                        <Col span={24}>
                            <div className="icon-wrapper-onb-tab">
                                <Row gutter={[0, 0]}>
                                { record.status === 'SENT' ?
                                <Col span={24}>
                                    <Icon type="file-pdf" className="file-pdf"
                                          onClick={ () =>
                                          handlePdfViewer(record) }
                                          style={{fontSize: '20px'}}
                                    />
                                </Col>
                                : !isInactiveUser &&
                                    <>
                                        <Col span={12}>
                                            <Icon 
                                                type="file-add" 
                                                theme="filled"
                                                style={{fontSize: '20px'}}
                                                onClick={ () => openForm(record) }
                                            />
                                        </Col>
                                        <Col span={12}>
                                            <Icon 
                                                type="delete"
                                                theme="filled"
                                                style={{fontSize: '20px'}}
                                                onClick={ () => showConfirm(record) }
                                            />
                                        </Col>
                                    </>
                                }
                                </Row>
                            </div>
                        </Col>
                    </Row>
                )
            })
        }
	]

    const openForm = async (form) => {
        if (isInactiveUser) {
            return
        }
		setIsLoading(true)
		setSelectedForm(form);
		setShowForm(true);
	}

    const exportForms = () => {
		ReportService.read('/portal/excelCDIDeclarationsByRecordId/' + currentUser.id, null, null, "declaraciones.xlsx")
	}

    const getTypeDeclaration = (type) => {
        return t('portal.cdi.option.' + type, {ns: 'forms'})
    }

    return ( 
        <div className="tab-onboarding-stakeholder">
            <Row gutter={[8, 16]} type="flex">
                <Col span={14}>
                    <div className="section">
                        { isLoading ? <div className="spin-wrapper"><Spin size='large'/></div> :
                            <>
                                <h3>{t('messages.aml.monitor.dashboard.notification')}</h3>
                                <div>
                                    <p>{t('portal.cdi.welcome.message', { name: currentUser.nombre, ns: "forms"})}</p>
                                    { items.length === 0 ?
                                        <p>{t('portal.cdi.welcome.message1', {ns: "forms"})}</p>
                                    : pendientes.length > 0 ?
                                        <p>{t('portal.cdi.welcome.message2', {clientName, lastPendingDate, ns: "forms"})}
                                        {" "}{isInactiveUser
                                            ? <span>{t('portal.cdi.welcome.message3', {type: getTypeDeclaration(pendientes[0].type), ns: "forms"})}</span>
                                            : <a style={{cursor: 'pointer'}} onClick={ () => openForm(pendientes[0]) }>{t('portal.cdi.welcome.message3', {type: getTypeDeclaration(pendientes[0].type), ns: "forms"})} </a>
                                        }.</p>
                                    : enviados.length > 0 ?
                                        <p>{t('portal.cdi.welcome.message4', {ns: "forms"})}{" "}{isInactiveUser
                                            ? <span>{t('portal.cdi.welcome.message5', {ns: "forms"})}</span>
                                            : <a style={{cursor: 'pointer'}} onClick={ () => openForm(enviados[0]) }>{t('portal.cdi.welcome.message5', {ns: "forms"})}</a>
                                        } {t('portal.cdi.welcome.message6', {lastEnviadoDate, ns: "forms"})} </p>
                                    :
                                        <p>{t('portal.cdi.welcome.message7', {lastDoneDate, ns: "forms"})}</p>
                                    }
                                </div>
                            </>
                        }
                    </div>
                </Col>
                <Col span={10}>
                    <div className="section">
                    { isLoading ? <div className="spin-wrapper"><Spin size='large'/></div> :
                        <>
                            <h3>{t('portal.cdi.support.title', {ns: "forms"})}</h3>
                            <div>
                                <p>{t('portal.cdi.welcome.message8', {clientName, ns: "forms"})}</p>
                                <p>{t('portal.cdi.welcome.message9', {email: 'soporte.aml@gesintel.cl', ns: "forms"})}</p>
                            </div> 
                        </>
                    }
                    </div>
                </Col>
            </Row>
            {getDeclOptions().length > 0 &&
                <Row gutter={[0, 16]}>
                    <Col span={24}>
                        <div className={`section${isInactiveUser ? ' section-disabled' : ''}`}>
                            <Row>
                                <Col span={24}>
                                    <h3>{t('portal.cdi.title.message1', {ns: "forms"})}</h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Row gutter={[10, 24]} type="flex" justify="space-around" align="middle">
                                        <Col span={1}>
                                            <Icon type="snippets" style={{fontSize: '20px'}}/>
                                        </Col>
                                        <Col span={6}>
                                            {t('portal.cdi.title.message2', {ns: 'forms'})}
                                        </Col>
                                        <Col span={11}>
                                            <Select
                                                style={{width: '100%'}}
                                                disabled={isInactiveUser}
                                                onChange={(e) => setSelectedTypeForm(e)}
                                            >
                                                { getDeclOptions().map(item => {
                                                    return(
                                                        <Option key={item.id} value={item.id}>{item.name}</Option>
                                                    ) 
                                                    })
                                                }
                                            </Select>
                                        </Col>
                                        <Col span={5} offset={1}>
                                            <Button type="primary"
                                                    disabled={isInactiveUser}
                                                    onClick={ () =>
                                                    { if (selectedTypeForm){ 
                                                            openForm()
                                                        }else{
                                                            message.error(t('portal.cdi.msg.message1', {ns: 'forms'}))
                                                        }
                                                    }}
                                            >{t('portal.cdi.title.message3', {ns: 'forms'})}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row gutter={[10, 24]}>
                                        <Col span={24}>
                                            {t('portal.cdi.welcome.message10', {ns: 'forms'})}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            }
            <Row gutter={[0, 16]}>
                <Col span={24}>
                    <div className="section">
                        <Row>
                            <Col span={18}>
                                <h3>{t('messages.aml.record')}</h3>
                            </Col>
                            <Col span={6} style={{textAlign:'right'}}>
                                <Icon 
                                    type="reload"
                                    onClick={handleRefresh}
                                    style={{fontSize: '20px', marginRight:'10px'}}
                                />
                                <Icon
                                    type="file-excel"
                                    style={{fontSize: '20px'}}
                                    onClick={exportForms}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Table dataSource={ items } columns={ tableColumns } size="small" loading={ isLoading }/>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            {formId &&
                <Modal
                    className="modal-pdf-viewer"
                    title="Formulario"
                    centered={true}
                    width={1000}
                    header={null}
                    footer={false}
                    onCancel={onCancelPdfViewer}
                    visible={true}
                    ><ModalPdfViewer
                        pdfId={formId}
                    />
                </Modal>
            }
            { showForm &&
                <FormModal client={client} currentUser={currentUser} typeForm={selectedForm ? selectedForm.type : selectedTypeForm} form={selectedForm} modalReady={modalReady} />
            }
        </div>
    );
}
 
export default TabCdiForms;